export const SET_EXAM_CRACKER_TESTS_DATA = "SET_EXAM_CRACKER_TESTS_DATA";